/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ErrorSupplier } from '../../suppliers/web';
import { isErrorThatNeedToBeShown, isFailedFetchError } from '../../core';

import type { LoggerServiceConfig } from './interfaces';

export class LoggerService {

    protected readonly messageProperty = 'exceptionText';

    protected readonly loggerUrl: string;

    protected readonly errorSupplier: ErrorSupplier;

    constructor(loggerServiceConfig: LoggerServiceConfig) {
        const {
            transportService,
            loggerUrl,
        } = loggerServiceConfig;

        this.loggerUrl = loggerUrl;

        this.errorSupplier = new ErrorSupplier(transportService);

        this.subscribeToWindowExceptions();
    }

    write(message: string): void {
        this.errorSupplier.writeLog(this.loggerUrl, {
            [this.messageProperty]: message,
            rcopAutoUpdate: true,
        })
            .catch((err) => {
                isErrorThatNeedToBeShown(err) && console.error(err);
            });
    }

    /**
     * Subscribe to window.onerror.
     */
    protected subscribeToWindowExceptions(): void {
        window.onerror = (msg, url, lineNo, columnNo, error) => {
            if (isFailedFetchError(error.message)) {
                if (process.env.NODE_ENV === 'development') {
                    console.error(`[DEV_MODE_MESSAGE] Logger ignore "${error.message}" error (via window.onerror)`);
                }
                return;
            }

            const exceptionMessage = [
                `Message: ${error?.message ? error.message : msg}`,
                `Source: ${url}`,
                `Line: ${lineNo}`,
                `Column: ${columnNo}`,
                error?.stack,
            ].join('\r\n');

            if (process.env.NODE_ENV === 'development') {
                console.error(`[DEV_MODE_MESSAGE] Logger try to send exception "${exceptionMessage}" (via window.onerror)`);
            }

            this.write(exceptionMessage);
        };
    }

}
